import { createContext, useContext } from 'react';

interface PaginationRestrictionContextValue {
  maxAllowedPage?: number;
  restrictionTooltip?: string;
}

const PaginationRestrictionContext = createContext<PaginationRestrictionContextValue>(
  {},
);

export const PaginationRestrictionProvider =
  PaginationRestrictionContext.Provider;

export const usePaginationRestriction = () =>
  useContext(PaginationRestrictionContext);
